import { odata } from '../../conf';

const actions = {
  async LOAD_reportExpenseLineItems({ commit, rootGetters }) {
    const data = await odata.o(rootGetters)
      .get('reportExpenseLineItems')
      .query({ $expand: 'ExpenseDocument' });
    commit('SET_reportExpenseLineItems', data);
  },
};

export default actions;
